
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import TheSearchbar from "@/components/TheSearcbar.vue";
import { ISearchBarViewModel, IUserModel } from "@/models";

@Component({
  name: "PageSearchForm",
  components: { TheSearchbar }
})
export default class PageSearchForm extends Vue {
  visible: boolean = false;

  @Prop()
  searchParams!: ISearchBarViewModel;

  get searchOptions(): ISearchBarViewModel {
    const searchForm = JSON.parse(localStorage.getItem("searchForm"));
    if (searchForm !== undefined && searchForm !== null) {
      const { category, state, date, searchText } = searchForm;
      return {
        category,
        state,
        date,
        searchText
      };
    } else if (this.searchParams === undefined) {
      return {
        category: 0,
        state: 0,
        date: 0,
        searchText: ""
      };
    }
    return Object.assign({}, this.searchParams);
  }

  @Emit("onSearchFormChange")
  onSearchFormChange(form: ISearchBarViewModel) {}

  onSearchChange(form: ISearchBarViewModel) {
    const parsed = JSON.stringify(form);
    localStorage.setItem("searchForm", parsed);
    this.onSearchFormChange(this.searchParams);
  }
}
